import loadable from '@loadable/component';

export const CmsContentPageLoadable = loadable(
  () => import('./CmsContentPage'),
  { resolveComponent: (module) => module.CmsContentPage },
);
